module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fc-Ga-Hc-Ia-Ga.a86e05b7.png";